import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient) { }

  search(criteria: any, from = 0, limit = 30) {
    return this.http.post<{ List: any[], Total: number }>(environment.app.apiUrl + `organization/search/${from}/${limit}`, criteria).toPromise();
  }

  tags() {
    return this.http.get<string[]>(environment.app.apiUrl + `organization/tags`).toPromise();
  }

  save(organization: any, imageOrRemoveImage?: File | boolean) {
    const formData = new FormData();
    const removeImage = imageOrRemoveImage == true;
    if (imageOrRemoveImage instanceof File) { formData.append('image', imageOrRemoveImage, imageOrRemoveImage.name); }
    formData.append('organization', JSON.stringify(organization));
    return this.http.post(environment.app.apiUrl + 'organization/save', formData,
      { params: { removeImage: removeImage.toString() } }).toPromise();
    // return this.http.post(environment.app.apiUrl + `organization/save`, organization).toPromise();
  }

  remove(organizationId: string) {
    return this.http.get(environment.app.apiUrl + `organization/remove/${organizationId}`).toPromise();
  }
}
